// extracted by mini-css-extract-plugin
module.exports = {"kicker":"KickerNew_kicker__xm13g"};